"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFixedClapprLoader = getFixedClapprLoader;
exports.getFixedClappr = getFixedClappr;

function getFixedClapprLoader() {
  var Loader = new Clappr.Loader();
  Loader.playbackPlugins = Loader.playbackPlugins.map(function (aPlugin) {
    if (aPlugin._fixed) return aPlugin;

    if (aPlugin.name == 'HLS') {
      var _class, _temp;

      return _temp = _class =
      /*#__PURE__*/
      function (_aPlugin) {
        babelHelpers.inherits(HLS, _aPlugin);

        function HLS() {
          babelHelpers.classCallCheck(this, HLS);
          return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(HLS).apply(this, arguments));
        }

        babelHelpers.createClass(HLS, [{
          key: "_setupHls",
          value: function _setupHls() {
            var _babelHelpers$get;

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(HLS.prototype), "_setupHls", this)).call.apply(_babelHelpers$get, [this].concat(args));

            var _hls = this._hls;

            _hls.on(_hls.constructor.Events.FRAG_LOADING, function (name, data) {
              var pos = _hls.levels[data.frag.level].details.fragments.indexOf(data.frag);

              var next = _hls.levels[data.frag.level].details.fragments[pos + 1];

              if (next && next.cc != data.frag.cc) {
                console.log("Fixing loadLevel across discontinuity", data.frag, next);
                _hls.loadLevel = data.frag.level;
              } else {
                _hls.loadLevel = -1;
              }
            });
          }
        }, {
          key: "settings",
          get: function get() {
            var _this = this;

            if (this._options.disableFullscreen && this._settings && babelHelpers.typeof(this._settings) == 'object') {
              Object.keys(this._settings).forEach(function (key) {
                if (Array.isArray(_this._settings[key])) {
                  _this._settings[key] = _this._settings[key].filter(function (v) {
                    return v != 'fullscreen';
                  });
                }
              });
            }

            return this._settings;
          },
          set: function set(value) {
            this._settings = value;
          }
        }]);
        return HLS;
      }(aPlugin), _class._fixed = true, _temp;
    }

    return aPlugin;
  });
  return Loader;
}

function getFixedClappr() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var Player = babelHelpers.construct(Clappr.Player, args);
  Player.loader = getFixedClapprLoader();
  return Player;
}